/* eslint-disable jsx-a11y/anchor-is-valid */
import { SubHeader } from "layout/SubHeader";
import React from "react";
import "../index.scss";
import PaymentForm from "./PaymentForm";
import PaymentsTable from "./PaymentsTable";

const Payments = () => {
  const [amount, setAmount] = React.useState(0);
  const [submit, setSubmit] = React.useState(false);
  const [toValue, setToValue] = React.useState(null);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const [valid, setValid] = React.useState(false);
  return (
    <div className="w-100">
      <div className="school-classes pr-12 pt-5">
        <div className="header">
          <div className="header-tittle align-items-end">
            <SubHeader
              className="subheader"
              {...{
                title: "Payments",
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <PaymentForm
          setToValue={setToValue}
          toValue={toValue}
          setAmount={setAmount}
          amount={amount}
          submit={submit}
          setValid={setValid}
          setSubmitLoading={setSubmitLoading}
        />
        <PaymentsTable
          submitLoading={submitLoading}
          valid={valid}
          setSubmit={setSubmit}
          amount={amount}
          toValue={toValue}
        />
      </div>
    </div>
  );
};

export default Payments;
